import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
`;
